import { Routes, Route, Navigate } from "react-router-dom";
import { Box } from "@mui/material";
import { MainLayout } from "./components/layout";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { LoginPage } from "./pages/LoginPage";
import { PasswordResetPage } from "./pages/PasswordResetPage";
import { DashboardPage } from "./pages/DashboardPage";
import { CustomersPage } from "./pages/CustomersPage";
import { CustomerDetailPage } from "./pages/CustomerDetailPage";
import { CustomerFormPage } from "./pages/CustomerFormPage";
import { ProductsPage } from "./pages/ProductsPage";
import { ProductFormPage } from "./pages/ProductFormPage";
import { ZonesPage } from "./pages/ZonesPage";
import { ZoneFormPage } from "./pages/ZoneFormPage";
import { CategoriesPage } from "./pages/CategoriesPage";
import { CategoryFormPage } from "./pages/CategoryFormPage";
import { DriversPage } from "./pages/DriversPage";
import { DriverFormPage } from "./pages/DriverFormPage";
import { OrdersPage } from "./pages/OrdersPage";
import { OrderFormPage } from "./pages/OrderFormPage";
import { OrderDetailPage } from "./pages/OrderDetailPage";
import { DeliveriesPage } from "./pages/DeliveriesPage";
import { DeliveriesByZonePage } from "./pages/DeliveriesByZonePage";
import { DeliveriesByDriverPage } from "./pages/DeliveriesByDriverPage";
import { DeliveriesMyPage } from "./pages/DeliveriesMyPage";
import { DeliveryMyDetailPage } from "./pages/DeliveryMyDetailPage";
import { ComponentsDemo } from "./pages/ComponentsDemo";
import { EnterprisesPage } from "./pages/EnterprisesPage";
import { EnterpriseFormPage } from "./pages/EnterpriseFormPage";
import { SocietyPage } from "./pages/SocietyPage";
import { AccountPage } from "./pages/AccountPage";
import { UsersPage } from "./pages/UsersPage";
import { IngredientsPage } from "./pages/IngredientsPage";
import { IngredientFormPage } from "./pages/IngredientFormPage";
import { AllergensPage } from "./pages/AllergensPage";
import { MenusPage } from "./pages/MenusPage";
import { RecurrentProductsPage } from "./pages/RecurrentProductsPage";
import { EstimationsPage } from "./pages/EstimationsPage";

// Portail client (espace client mobile)
import { CustomerProtectedRoute } from "./client/components/CustomerProtectedRoute";
import { ClientRegisterPage } from "./client/pages/ClientRegisterPage";
import { ClientHomePage } from "./client/pages/ClientHomePage";
import { ClientAccountPage } from "./client/pages/ClientAccountPage";
import { ClientAddressesPage } from "./client/pages/ClientAddressesPage";
import { ClientAddressFormPage } from "./client/pages/ClientAddressFormPage";
import { ClientAllergensPage } from "./client/pages/ClientAllergensPage";
import { ClientOrderPage } from "./client/pages/ClientOrderPage";
import { ClientOrdersPage } from "./client/pages/ClientOrdersPage";
import { ClientOrderDetailPage } from "./client/pages/ClientOrderDetailPage";
import { ClientCheckoutResultPage } from "./client/pages/ClientCheckoutResultPage";

function App(): JSX.Element {
  return (
    <Box sx={{ minHeight: "100vh", backgroundColor: "background.default" }}>
      <Routes>
        {/* Routes publiques */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/password-reset" element={<PasswordResetPage />} />

        {/* Portail client (espace client mobile) — connexion via /login */}
        <Route path="/client/register" element={<ClientRegisterPage />} />
        <Route
          path="/client/password-reset"
          element={<PasswordResetPage />}
        />
        <Route
          path="/client"
          element={
            <CustomerProtectedRoute>
              <ClientHomePage />
            </CustomerProtectedRoute>
          }
        />
        <Route
          path="/client/order/new"
          element={
            <CustomerProtectedRoute>
              <ClientOrderPage />
            </CustomerProtectedRoute>
          }
        />
        <Route
          path="/client/orders"
          element={
            <CustomerProtectedRoute>
              <ClientOrdersPage />
            </CustomerProtectedRoute>
          }
        />
        <Route
          path="/client/orders/:id"
          element={
            <CustomerProtectedRoute>
              <ClientOrderDetailPage />
            </CustomerProtectedRoute>
          }
        />
        <Route
          path="/client/checkout/result"
          element={
            <CustomerProtectedRoute>
              <ClientCheckoutResultPage />
            </CustomerProtectedRoute>
          }
        />
        <Route
          path="/client/account"
          element={
            <CustomerProtectedRoute>
              <ClientAccountPage />
            </CustomerProtectedRoute>
          }
        />
        <Route
          path="/client/account/addresses/new"
          element={
            <CustomerProtectedRoute>
              <ClientAddressFormPage />
            </CustomerProtectedRoute>
          }
        />
        <Route
          path="/client/account/addresses/:addressId/edit"
          element={
            <CustomerProtectedRoute>
              <ClientAddressFormPage />
            </CustomerProtectedRoute>
          }
        />
        <Route
          path="/client/account/addresses"
          element={
            <CustomerProtectedRoute>
              <ClientAddressesPage />
            </CustomerProtectedRoute>
          }
        />
        <Route
          path="/client/account/allergens"
          element={
            <CustomerProtectedRoute>
              <ClientAllergensPage />
            </CustomerProtectedRoute>
          }
        />

        {/* Routes protégées avec layout */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <MainLayout>
                <DashboardPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/account"
          element={
            <ProtectedRoute>
              <MainLayout>
                <AccountPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/society"
          element={
            <ProtectedRoute>
              <MainLayout>
                <SocietyPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/users"
          element={
            <ProtectedRoute>
              <MainLayout>
                <UsersPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />

        {/* Routes Commandes */}
        <Route
          path="/orders"
          element={
            <ProtectedRoute>
              <MainLayout>
                <OrdersPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/orders/new"
          element={
            <ProtectedRoute>
              <MainLayout>
                <OrderFormPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/orders/:id/edit"
          element={
            <ProtectedRoute>
              <MainLayout>
                <OrderFormPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/orders/:id"
          element={
            <ProtectedRoute>
              <MainLayout>
                <OrderDetailPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/estimations"
          element={
            <ProtectedRoute>
              <MainLayout>
                <EstimationsPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />

        {/* Routes Livreur (Mes livraisons) */}
        <Route
          path="/deliveries/my"
          element={
            <ProtectedRoute>
              <MainLayout>
                <DeliveriesMyPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/deliveries/my/detail/:deliveryId"
          element={
            <ProtectedRoute>
              <MainLayout>
                <DeliveryMyDetailPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />

        {/* Routes Livraisons */}
        <Route
          path="/deliveries"
          element={
            <ProtectedRoute>
              <MainLayout>
                <DeliveriesPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/deliveries/by-zone"
          element={
            <ProtectedRoute>
              <MainLayout>
                <DeliveriesByZonePage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/deliveries/by-driver"
          element={
            <ProtectedRoute>
              <MainLayout>
                <DeliveriesByDriverPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />

        {/* Routes Clients */}
        <Route
          path="/customers"
          element={
            <ProtectedRoute>
              <MainLayout>
                <CustomersPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/customers/new"
          element={
            <ProtectedRoute>
              <MainLayout>
                <CustomerFormPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/customers/:id/edit"
          element={
            <ProtectedRoute>
              <MainLayout>
                <CustomerFormPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/customers/:id"
          element={
            <ProtectedRoute>
              <MainLayout>
                <CustomerDetailPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />

        {/* Routes Entreprises */}
        <Route
          path="/enterprises"
          element={
            <ProtectedRoute>
              <MainLayout>
                <EnterprisesPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/enterprises/new"
          element={
            <ProtectedRoute>
              <MainLayout>
                <EnterpriseFormPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/enterprises/:id/edit"
          element={
            <ProtectedRoute>
              <MainLayout>
                <EnterpriseFormPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />

        {/* Routes Produits */}
        <Route
          path="/products"
          element={
            <ProtectedRoute>
              <MainLayout>
                <ProductsPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/products/new"
          element={
            <ProtectedRoute>
              <MainLayout>
                <ProductFormPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/products/:id/edit"
          element={
            <ProtectedRoute>
              <MainLayout>
                <ProductFormPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />

        {/* Routes Zones */}
        <Route
          path="/zones"
          element={
            <ProtectedRoute>
              <MainLayout>
                <ZonesPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/zones/new"
          element={
            <ProtectedRoute>
              <MainLayout>
                <ZoneFormPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/zones/:id/edit"
          element={
            <ProtectedRoute>
              <MainLayout>
                <ZoneFormPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />

        {/* Routes Catégories */}
        <Route
          path="/categories"
          element={
            <ProtectedRoute>
              <MainLayout>
                <CategoriesPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/categories/new"
          element={
            <ProtectedRoute>
              <MainLayout>
                <CategoryFormPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/categories/:id/edit"
          element={
            <ProtectedRoute>
              <MainLayout>
                <CategoryFormPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />

        {/* Routes Ingrédients */}
        <Route
          path="/ingredients"
          element={
            <ProtectedRoute>
              <MainLayout>
                <IngredientsPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/ingredients/new"
          element={
            <ProtectedRoute>
              <MainLayout>
                <IngredientFormPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/ingredients/:id/edit"
          element={
            <ProtectedRoute>
              <MainLayout>
                <IngredientFormPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />

        {/* Routes Allergènes (référentiel lecture seule) */}
        <Route
          path="/allergens"
          element={
            <ProtectedRoute>
              <MainLayout>
                <AllergensPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />

        {/* Routes Menus hebdomadaires */}
        <Route
          path="/menus"
          element={
            <ProtectedRoute>
              <MainLayout>
                <MenusPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/recurrent-products"
          element={
            <ProtectedRoute>
              <MainLayout>
                <RecurrentProductsPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />

        {/* Routes Livreurs */}
        <Route
          path="/drivers"
          element={
            <ProtectedRoute>
              <MainLayout>
                <DriversPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/drivers/new"
          element={
            <ProtectedRoute>
              <MainLayout>
                <DriverFormPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/drivers/:id/edit"
          element={
            <ProtectedRoute>
              <MainLayout>
                <DriverFormPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />

        {/* Route de démonstration des composants */}
        <Route
          path="/components-demo"
          element={
            <MainLayout>
              <ComponentsDemo />
            </MainLayout>
          }
        />

        {/* Routes par défaut */}
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Box>
  );
}

export default App;
